import { Injectable } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { ApiService } from "../services/api.service";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { ApiCollection } from "../providers/api-collection";
import { BehaviorSubject, Subject } from "rxjs";
import { SearchItem } from "../models/masterSearch.model";


@Injectable({providedIn:"root",})

export class SearchViewModel {
    constructor(
            private apiService: ApiService,
            private message: NzMessageService
            ) { }

   private searchDataList = new BehaviorSubject<SearchItem>(new SearchItem())
    _searchDataList = this.searchDataList.asObservable();

    
    getMasterSeacrhList(page:number, page_size:number, search:string, type: string){
        let url = ApiCollection.masterSearch +'?page='+page+'&page_size='+page_size + '&string=' + encodeURIComponent(search);
        url += '&filter_on=' + type;
        let d: ApiServiceDelegate = {
            Data: { },
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.searchDataList.next(e)
            //    console.log(e)
                return e;
            },
            Error: (e: String) => {
        
                return e;
            },
        };
        this.apiService.callService(d);
    }


    }       
